import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.context';
import { COLUMN_IDS } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.helpers';
import Skeleton from 'react-loading-skeleton';
import styles from './TableLoaderRow.module.css';

export const TableLoaderRow = () => {
  const { table } = useApplicationsTableState();

  const getCellSkeleton = (columnId: string) => {
    switch (columnId) {
      case COLUMN_IDS.companyName:
        return (
          <div className={styles.companyName}>
            <div className={styles.companyDetails}>
              <Skeleton width={200} baseColor="var(--color-structure-80)" />
              <Skeleton width={80} />
            </div>
            <Skeleton height={36} width={65} />
          </div>
        );
      case COLUMN_IDS.status:
        return (
          <Skeleton
            height={40}
            width={110}
            baseColor="var(--color-structure-80)"
          />
        );
      case COLUMN_IDS.expiryDate:
        return <Skeleton width={90} />;
      default:
        return <Skeleton width={115} />;
    }
  };

  return (
    <tr data-testid="table-loader-row">
      {table.getVisibleLeafColumns().map((column) => (
        <td
          key={column.id}
          style={{ width: table.getColumn(column.id)?.getSize() }}
          className={styles.cell}
        >
          {getCellSkeleton(column.id)}
        </td>
      ))}
    </tr>
  );
};
